import { render, staticRenderFns } from "./ConsumptionsForm.vue?vue&type=template&id=f4576fd6"
import script from "./ConsumptionsForm.vue?vue&type=script&lang=ts"
export * from "./ConsumptionsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports